<h2 mat-dialog-title>{{ 'chatbot.report_problem' | translate }}</h2>
<mat-dialog-content>
  <p>{{ 'chatbot.report_problem_description' | translate }}</p>
  <mat-form-field
    appearance="outline"
    class="w-100"
  >
    <mat-label>{{ 'chatbot.problem_details' | translate }}</mat-label>
    <textarea
      matInput
      [(ngModel)]="details"
      rows="4"
    ></textarea>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    mat-button
    (click)="cancel()"
  >
    {{ 'general.cancel' | translate }}
  </button>
  <button
    mat-flat-button
    color="warn"
    (click)="report()"
  >
    {{ 'general.tooltips.send' | translate }}
  </button>
</mat-dialog-actions>
